import { del, get, post, put } from "../api";

export async function searchValidatedListings(searchType, searchValue) {
    const params = new URLSearchParams({ type: searchType, value: searchValue });
    return await get(`tool/validated-search?${params.toString()}`);
}

export async function updateValidatedListingPicture(publicId, base64Picture) {
    return await post({ base64Picture }, `tool/validated/${publicId}/picture`);
}

export async function updateValidatedListing(publicId, values) {
    return await put(values, `tool/validated/${publicId}`);
}

export async function deleteValidatedListing(publicId) {
    return await del(`tool/validated/${publicId}`);
}

export async function addValidatedListingAdvice(publicId, message) {
    return await post({ message }, `tool/validated/${publicId}/advice`);
}
